var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNcChatBotSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 21.5C4.21675 21.5 3.82642 21.3347 3.49575 21.0042C3.16525 20.6736 3 20.2833 3 19.8333V5.16675C3 4.71675 3.16525 4.32642 3.49575 3.99575C3.82642 3.66525 4.21675 3.5 4.66675 3.5H16.0333L21 8.46675V19.8333C21 20.2833 20.8347 20.6736 20.5042 21.0042C20.1736 21.3347 19.7833 21.5 19.3333 21.5H4.66675ZM4.66675 19.8333H19.3333V9.35725H15.15V5.16675H4.66675V19.8333ZM6.98325 17.3168H17.0167V15.65H6.98325V17.3168ZM6.98325 9.35H12V7.68325H6.98325V9.35ZM6.98325 13.3333H17.0167V11.6667H6.98325V13.3333Z",
    fill: "#A50DFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcChatBotSidebar);
export default __webpack_public_path__ + "static/media/nc-chat-bot-sidebar.d37dd9ac255607368b1442d1c2984491.svg";
export { ForwardRef as ReactComponent };